import FavoriteService from "@/services/favorite.service";

export const favorite = {
    namespaced: true,
    state:{
        groups:[],
        items:[]
    },
    mutations:{
        setGroups(state, groups){
            state.groups = groups;
        },
        setItems(state, items){
            state.items = items;
        }
    },
    actions:{
        async loadGroups({commit}){
            const groups =
                await FavoriteService.getGroups();

            commit(
                "setGroups",
                groups
            );
        },
        async loadItems({ commit }, groupId) {
            const items =
                await FavoriteService.getItems(groupId);
                
            commit(
                "setItems",
                items
            );

            return items;
        },
        async createGroup({dispatch}, name){
            await FavoriteService.createGroup(name);
            await dispatch(
                "loadGroups"
            );
        },
        async addFavorite({dispatch}, payload){
            await FavoriteService.addFavorite(
                payload.groupId,
                payload.files
            );

            await dispatch(
                "loadItems",
                payload.groupId
            );
        },
        async deleteItem({dispatch}, payload){
            await FavoriteService.deleteItem(
                payload.groupId,
                payload.itemId
            );

            await dispatch(
                "loadItems",
                payload.groupId
            );
        }
    }
};